import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import list from './list';

const Messages = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/:id`} component={list}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);

export default Messages;
